<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      left-arrow
      title="我的拍卖"
      z-index="10"
      @click-left="goableBack()">
    </van-nav-bar>
    <van-tabs
      class="tabs-bg"
      v-model="tabActive"
      swipeable
      sticky
      line-height="3"
      title-active-color="rgb(0, 0, 0)"
      title-inactive-color="rgb(133, 133, 133)"
      offset-top="46">
      <van-tab
        v-for="(item, index) in tabsList"
        :title="item.title"
        :key="index">
        <div class="container">
          <AuctionList :tabObject="item" :active="tabActive"> </AuctionList>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs } from "vant"
import AuctionList from "./auctionList.vue"
import session from "../../utils/session"
export default {
  name: "myauction",
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    AuctionList
  },
  data() {
    return {
      tabActive: 0,
      tabsList: [
        { title: "持有中", type: "2" },
        { title: "申请中", type: "1" },
        { title: "已结清", type: "3" }
      ]
    }
  },
  beforeMount() {},
  watch: {},
  mounted() {
    if (session.get("myauction-tab")) {
      this.tabActive = Number(session.get("myauction-tab"))
      session.del("myauction-tab")
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
// 下划线设置
// ::v-deep .van-tabs__line {
//   position: absolute;
//   bottom: 20px;
//   left: 0;
//   z-index: 1;
//   height: 3px;
//   width: 30px !important;
//   background-color: #fc6524;
//   border-radius: 0.08rem;
// }
// 文本选择和默认颜色设置
// ::v-deep .van-tab {
//   color: #999;
// }
// ::v-deep .van-tab--active {
//   color: #333333;
// }
// 文本字体设置
::v-deep .van-tab__text {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  // background: rgba(255, 255, 255, 0.6);
}
::v-deep .van-hairline--top-bottom:after {
  border: none;
}
</style>>
